import { store } from 'redux/store';
import { isAuthenticated } from 'utils/auth';
import { apiInterceptor } from 'utils/apiInterceptor';
export async function DeleteProduct(
    projectId,
    productId,
) {
    const user = store?.getState()?.user
    if (isAuthenticated() && user) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/products/${productId}?projectId=${projectId}`,
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return await response.json();
    }
}